import { WprModel } from '../../wpr-framework/view/deco/WprModel';
import { WprViewMode } from '../../wpr-framework/view/deco/WprViewMode';
import { PlanSelectMode } from './mode/PlanSelectMode';
import { PlanCheckMode } from './mode/PlanCheckMode';
import { WprDI_Control } from '../../wpr-framework/view/di/WprDI_Control';
import { WprControlInfo } from '../../wpr-framework/view/control/WprControlInfo';
import { PlanMultiMode } from './mode/PlanMultiMode';
import { OptionInfo } from '../../models/OptionInfo';
import { FirstScopeInfo } from '../../scope/FirstScopeInfo';
import { RiskFactorInfo } from '../../service/models/risk-factor/risk-factor-info';
import { BaseWindowViewScope } from '../base/BaseWindowViewScope';
import { postUtagView, postUtagEvent, UTAG_EVENT_JSON } from '../../../public/utag';
import { SelectPlanInfo } from '../../service/models/select-plan/select-plan-info';
import { WprListData } from '../../wpr-framework/view/deco/WprListData';
import { WprDI_ScopeModel } from '../../wpr-framework/view/di/WprDI_ScopeModel';
import { ContractNoticeService } from '../../service/ContractNoticeService';
import { ContractNoticeRequest } from '../../service/service-models/contract-notice/ContractNoticeReqesut';
import { ContractNoticeInfo } from '../../service/models/contract-notice/contract-notice-info';
import { OthersInfo } from '../../models/OthersInfo';
import { WprDI_GlobalScopeModel } from '../../wpr-framework/view/di/WprDI_GlobalScopeModel';
import { CollateralDisplayInfo } from '../../service/models/collateral-display/collateral-display-info';
import { PlanInfo } from '../../models/PlanInfo';
import { CollateralShortNameInfo } from '../../models/CollateralShortNameInfo';
import { CollateralInfo } from '../../models/CollateralInfo';
/**
 * 保険プランの選択
 */
export class PlanComponentView extends BaseWindowViewScope<FirstScopeInfo> {
	// private変数  ------------------------------------------------------------------
	private m_CollAndQuesMap: Map<string, string> 					= new Map<string, string>();	//	補償表示とクエスチョンキーの連想配列
	// --------------------------------------------------------------------------

	// DI情報  ------------------------------------------------------------------
	@WprDI_Control
	private m_Type: WprControlInfo 									= null;							// プラン選択ボタン
	@WprDI_Control
	private m_Yes: WprControlInfo 									= null;							// オプション追加情報
	// --------------------------------------------------------------------------
	
	// モデル  ------------------------------------------------------------------
	@WprDI_GlobalScopeModel('agentcode')
	private m_AgentCode: string 									= null;							// 代理店コード
	@WprDI_GlobalScopeModel('product')
	private m_ProductCode: string 									= null;							// 商品コード
	// WRQ-3496_ 【旅行保険】代理店追加対応 阪急交通社(ホワイトラベル）
	@WprDI_GlobalScopeModel('inquiryNo')
	private m_MemberNo: string 										= null;							// 会員番号	
	// WRQ-3496_ 【旅行保険】代理店追加対応 阪急交通社(ホワイトラベル）

	// プラン表示情報
	@WprModel('PlanInfo1')
	private m_PlanInfo1: PlanInfo 									= null;							// プラン1情報
	@WprModel('PlanInfo2')
	private m_PlanInfo2: PlanInfo 									= null;							// プラン2情報
	@WprModel('PlanInfo3')
	private m_PlanInfo3: PlanInfo 									= null;							// プラン3情報
	@WprDI_ScopeModel('OptionInfo')
	@WprModel('OptionInfo')
	private m_OptionInfo: OptionInfo 								= null;							// オプション情報
	@WprDI_ScopeModel('OptionFlag')
	private m_OptionFlg: boolean		 							= false;						// オプションフラグ
	@WprDI_ScopeModel('PlanInfoList')
	private m_PlanInfoList: PlanInfo[] 								= null;							// プランリスト
	@WprDI_ScopeModel('CollKeyList')
	private m_CollKeyList: string[] 								= null;							// 補償キーリスト
	@WprDI_ScopeModel('CollDispList')
	@WprListData('CollDispList')
	private m_CollDispList: CollateralDisplayInfo[]					= null;							// 補償表示リスト
	@WprDI_ScopeModel('ExtraCollDispInfo')	
	@WprModel('ExtraCollDispInfo')
	private m_ExtraCollDispInfo: CollateralDisplayInfo				= null;							// 追加補償表示情報
	@WprModel('CollateralShortNameInfo')
	private m_CollateralShortNameInfo: CollateralShortNameInfo 		= null;							// 補償略称名
	@WprDI_ScopeModel('RiskFactorInfo')
	private m_RiskFactorInfo: RiskFactorInfo						= null;							// リスクファクター情報
	@WprDI_ScopeModel('SelectPlanInfo')
	@WprModel('SelectPlanInfo')
	private m_SelectPlanInfo: SelectPlanInfo 						= null;							// 選択プラン情報
	@WprDI_ScopeModel('ContractNoticeInfo')
	@WprListData('ContractNoticeInfo')
	private m_ContractNoticeList: ContractNoticeInfo[] 				= null; 						// 告知事項情報
	@WprDI_ScopeModel('OthersInfo')
	private m_OthersInfo: 	OthersInfo 								= null; 						// その他情報
	// -------------------------------------------------------------------------

	// サービス  -----------------------------------------------------------------
	private m_ContractNoticeService: ContractNoticeService 			= new ContractNoticeService();	// 告知事項
	// --------------------------------------------------------------------------

	// サブビュー/モード  ---------------------------------------------------------
	@WprViewMode
	private m_ViewMode1 = new PlanSelectMode(); // プラン別色切り替えモード
	@WprViewMode
	private m_ViewMode3 = new PlanCheckMode(); 	// プラン選択チェックモード
	@WprViewMode
	private m_ViewMode4 = new PlanMultiMode();	// プランマルチモード
	// -------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	constructor() {
		super('step2_plan');
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * コントロール定義設定
	 */
	public onRegisterConfig(): void {
		super.onRegisterConfig();
		this.addConfig('type', 'ラジオボタン情報', null);
		this.addConfig('close', 'ヘルプ閉じるボタン', null);
		this.addConfig('buttonName', '次へボタンラベル', null);
		this.addConfig('q-1', 'ヘルプ1表示ボタン', null);
		this.addConfig('q-2', 'ヘルプ2表示ボタン', null);
		this.addConfig('q-3', 'ヘルプ3表示ボタン', null);
		this.addConfig('q-4', 'ヘルプ4表示ボタン', null);
		this.addConfig('q-5', 'ヘルプ5表示ボタン', null);
		this.addConfig('q-6', 'ヘルプ6表示ボタン', null);
		this.addConfig('q-7', 'ヘルプ表示7ボタン', null);
		// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 START
		this.addConfig('q-8', 'ヘルプ8表示ボタン', null);
		// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 END
		
		this.addConfig('reasonable', 'リーズナブル', null);
		this.addConfig('standard', 'スタンダード', null);
		this.addConfig('premium', 'プレミアム', null);
		this.addConfig('reasonablebtn', 'リーズナブルボタン', null);
		this.addConfig('standardbtn', 'スタンダードボタン', null);
		this.addConfig('premiumbtn', 'プレミアムボタン', null);
		this.addConfig('reasonableFee', 'リーズナブルプラン料金', 'PlanInfo1', { bindName: 'totalPremium' });
		this.addConfig('standardFee', 'スタンダードプラン料金', 'PlanInfo2', { bindName: 'totalPremium' });
		this.addConfig('premiumFee', 'プレミアムプランサマリ', 'PlanInfo3', { bindName: 'totalPremium' });
		this.addConfig('reasonableName', 'リーズナブル名', 'PlanInfo1', { bindName: 'planName' });
		this.addConfig('standardName', 'スタンダード名', 'PlanInfo2', { bindName: 'planName' });
		this.addConfig('premiumName', 'プレミアム名', 'PlanInfo3', { bindName: 'planName' });
		this.addConfig('reasonableSummary', 'リーズナブルサマリ', 'PlanInfo1', { bindName: 'summary' });
		this.addConfig('standardSummary', 'スタンダードサマリ', 'PlanInfo2', { bindName: 'summary' });
		this.addConfig('premiumSummary', 'プレミアムサマリ', 'PlanInfo3', { bindName: 'summary' });

		this.addConfig('value1_1', 'プラン1情報', 'PlanInfo1', { bindName: 'value1' });
		this.addConfig('value1_2', 'プラン1情報', 'PlanInfo1', { bindName: 'value2' });
		this.addConfig('value1_3', 'プラン1情報', 'PlanInfo1', { bindName: 'value3' });
		this.addConfig('value1_4', 'プラン1情報', 'PlanInfo1', { bindName: 'value4' });
		this.addConfig('value1_5', 'プラン1情報', 'PlanInfo1', { bindName: 'value5' });
		this.addConfig('value1_6', 'プラン1情報', 'PlanInfo1', { bindName: 'value6' });
		// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 START
		this.addConfig('value1_8', 'プラン1情報', 'PlanInfo1', { bindName: 'value8' });
		// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 END

		this.addConfig('value2_1', 'プラン2情報', 'PlanInfo2', { bindName: 'value1' });
		this.addConfig('value2_2', 'プラン2情報', 'PlanInfo2', { bindName: 'value2' });
		this.addConfig('value2_3', 'プラン2情報', 'PlanInfo2', { bindName: 'value3' });
		this.addConfig('value2_4', 'プラン2情報', 'PlanInfo2', { bindName: 'value4' });
		this.addConfig('value2_5', 'プラン2情報', 'PlanInfo2', { bindName: 'value5' });
		this.addConfig('value2_6', 'プラン2情報', 'PlanInfo2', { bindName: 'value6' });
		// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 START
		this.addConfig('value2_8', 'プラン2情報', 'PlanInfo2', { bindName: 'value8' });
		// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 END
		
		this.addConfig('value3_1', 'プラン3情報', 'PlanInfo3', { bindName: 'value1' });
		this.addConfig('value3_2', 'プラン3情報', 'PlanInfo3', { bindName: 'value2' });
		this.addConfig('value3_3', 'プラン3情報', 'PlanInfo3', { bindName: 'value3' });
		this.addConfig('value3_4', 'プラン3情報', 'PlanInfo3', { bindName: 'value4' });
		this.addConfig('value3_5', 'プラン3情報', 'PlanInfo3', { bindName: 'value5' });
		this.addConfig('value3_6', 'プラン3情報', 'PlanInfo3', { bindName: 'value6' });
		// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 START
		this.addConfig('value3_8', 'プラン3情報', 'PlanInfo3', { bindName: 'value8' });
		// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 END
		
		this.addConfig('value7', 'オプション情報', 'OptionInfo', { bindName: 'value7' });
		this.addConfig('optionFee', 'オプション情報', 'OptionInfo', { bindName: 'optionFee' });
	
		this.addConfig('li1_1', '傷害死亡1', null);
		this.addConfig('li1_2', '傷害後遺障害1', null);
		this.addConfig('li1_3', '疫病死亡1', null);
		this.addConfig('li1_4', '治療救援費用1', null);
		this.addConfig('li1_5', '賠償責任1', null);
		this.addConfig('li1_6', '携行品損害1', null);
		// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 START
		this.addConfig('li1_8', '手術1', null);
		// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 END
		this.addConfig('li2_1', '傷害死亡2', null);
		this.addConfig('li2_2', '傷害後遺障害2', null);
		this.addConfig('li2_3', '疫病死亡2', null);
		this.addConfig('li2_4', '治療救援費用2', null);
		this.addConfig('li2_5', '賠償責任2', null);
		this.addConfig('li2_6', '携行品損害2', null);
		// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 START
		this.addConfig('li2_8', '手術2', null);
		// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 END
		this.addConfig('li3_1', '傷害死亡3', null);
		this.addConfig('li3_2', '傷害後遺障害3', null);
		this.addConfig('li3_3', '疫病死亡3', null);
		this.addConfig('li3_4', '治療救援費用3', null);
		this.addConfig('li3_5', '賠償責任3', null);
		this.addConfig('li3_6', '携行品損害3', null);
		// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 START
		this.addConfig('li3_8', '手術3', null);
		// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 END
		this.addConfig('label1', '傷害死亡/死亡後遺障害', 'CollateralShortNameInfo');
		this.addConfig('label2', '障害後後遺症害/入院', 'CollateralShortNameInfo');
		this.addConfig('label3', '疫病死亡/通院', 'CollateralShortNameInfo');
		this.addConfig('label4', '賠償責任', 'CollateralShortNameInfo');
		this.addConfig('label5', '治療救援費用/救援費用', 'CollateralShortNameInfo');
		this.addConfig('label6', '携行品損害', 'CollateralShortNameInfo');
		this.addConfig('label7', '旅行中の事故による緊急費用/航空機欠航等宿泊費保険金', 'ExtraCollDispInfo', { bindName: 'collateralShortName'});
		// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 START
		this.addConfig('label8', '手術', 'CollateralShortNameInfo');
		// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 END
		this.addConfig('yes', '追加する', null);
		this.addConfig('planName', '選択プラン名', null);
		// this.addConfig('optionName', 'オプション名', 'ExtraCollDispInfo', { bindName: 'collateralShortName'});
		this.addConfig('addOption', 'オプション追加', null);
		this.addConfig('totalPremium', '合計保険料', 'SelectPlanInfo', { bindName: 'totalPremium' });
		this.addConfig('extraCollName', '追加モーダル内補償名', 'ExtraCollDispInfo', { bindName: 'displayCollateralName' });
		this.addConfig('extraCollDesc', '追加モーダル内補償説明', 'ExtraCollDispInfo', { bindName: 'collateralDescription' });	
		this.addListConfig('collName', 'モーダル内補償名', 'CollDispList', { bindName: 'displayCollateralName' });
		this.addListConfig('collDesc', 'モーダル内補償説明', 'CollDispList', { bindName: 'collateralDescription' });
	}

	/**
	 * アクション登録
	 */
	public onRegisterAction(): void {
		super.onRegisterAction();
		this.addAction('q-1', this.onHelpShow);
		this.addAction('q-2', this.onHelpShow);
		this.addAction('q-3', this.onHelpShow);
		this.addAction('q-4', this.onHelpShow);
		this.addAction('q-5', this.onHelpShow);
		this.addAction('q-6', this.onHelpShow);
		this.addAction('q-7', this.onHelpShow);
		// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 START
		this.addAction('q-8', this.onHelpShow);
		// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 END
		this.addAction('close', this.onClose);
		this.addAction('next', this.onNext);
	}

	/**
	 * ビュー表示通知
	 */
	public onShowView(): void {
		super.onShowView();
		if (this.m_CollDispList) {
			this.setScopeModel('PlanInfoList', this.m_PlanInfoList);
			this.setScopeModel('ExtraCollDispInfo', this.m_ExtraCollDispInfo);
			this.setScopeModel('CollDispList', this.m_CollDispList);
			this.setListData('CollDispList', this.m_CollDispList);
			this.setScopeModel('CollKeyList', this.m_CollKeyList);
			this.m_CollateralShortNameInfo  = new CollateralShortNameInfo();
			this.m_PlanInfo1 = this.setPlan(0);
			this.m_PlanInfo2 = this.setPlan(1);
			this.m_PlanInfo3 = this.setPlan(2);
			if (this.prevViewName === 'step3_important') {
				this.setPrevPlan();
				this.setPrevPlanOption();
				this.setViewMode('totalPremium', 'selected');
				if (this.m_Yes.value === true) {
					this.setViewMode('option', '表示');
				}			
			}
			else {
				this.setShowPlan();
				this.setOption();
			}
			this.onUtagView();
			this.refreshModel();
			this.refreshView();
		}
		else {
			this.onViewError();
		}
	}

	/**
	 * 値変更通知
	 * @param name 名前
	 * @param value 値
	 * @returns falseの場合、変更を取り消す
	 */
	public onChangeValue(name: string, value: any): boolean {		
		if (name === 'type') {
			this.setViewMode('totalPremium', 'selected');
		}
		if (this.m_Type.value === 'reasonable')
			this.m_SelectPlanInfo.totalPremium = this.m_PlanInfo1.totalPremium;
		else if (this.m_Type.value === 'standard')
			this.m_SelectPlanInfo.totalPremium = this.m_PlanInfo2.totalPremium;
		else if (this.m_Type.value === 'premium')
			this.m_SelectPlanInfo.totalPremium = this.m_PlanInfo3.totalPremium;			
		if(this.m_Yes.value === true) {
			this.m_SelectPlanInfo.totalPremium += this.m_OptionInfo.optionFee;
			this.setViewMode('option', '表示');
		}
		else {
			this.setViewMode('option', '');
		}
		this.m_SelectPlanInfo.totalPremium *= this.m_RiskFactorInfo.numberOfInsured;
		this.refreshView();
		this.setUtagEvent(name, value);
		return true;
	}

	/**
	 * ウインドウスクロール通知
	 * @param pageXOffset Xオフセット
	 * @param pageYOffset Yオフセット
	 */
	public onScrollWindow(pageXOffset: number, pageYOffset: number): void {
		super.onScrollWindow(pageXOffset, pageYOffset);
		let hight = 600;
		if (navigator.userAgent.indexOf('iPhone') > 0)
			hight = 430;
		if (pageYOffset > hight) {
			this.setViewMode('viewMode2', '表示');
			this.updateMode(true);
		}
		else {
			this.setViewMode('viewMode2', '');
		}
	}

	/**
	 * Tealium Utag View　追加処理
	 */
	public onExtraUtagView(utagView: any): void {
		utagView.quote_prev_expiry_date = this.m_RiskFactorInfo.startDate;
		utagView.quote_expiry_date 		= this.m_RiskFactorInfo.endDate;
		utagView.endorser 				= this.m_AgentCode;
		utagView.country 				= this.m_RiskFactorInfo.destinationCountryCode;
		utagView.number_of_parson 		= this.m_RiskFactorInfo.numberOfInsured;
		utagView.purpose 				= this.m_RiskFactorInfo.purposeCode;
	}

	/**
	 * Tealium Event Tag 設定処理
	 * @param param 
	 */
	public setUtagEvent(param: any, value: any): void {
		const cat 			= UTAG_EVENT_JSON[0].plan;
		const evVal 		= UTAG_EVENT_JSON[2].ev_value;
		let label: string 	= null;
		if(param.includes('q-')) {
			if(this.productCode === 'DTP') {
				if(param === 'q-1')	label = 'dtp_syogai_kouisyogai';
				if(param === 'q-2') label = 'dtp_nyuin';
				if(param === 'q-3') label = 'dtp_tsuin';
				if(param === 'q-5') label = 'dtp_kyuensya';
				if(param === 'q-7') label = 'dtp_option_kekkou';
				// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 START
				if(param === 'q-8') 	label = 'dtp_syujyutsu';
				// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 END
			}
			else {
				if(param === 'q-1')	label = 'ota_syogai_shibou';
				if(param === 'q-2')	label = 'ota_syogai_kouisyogai';
				if(param === 'q-3')	label = 'ota_shippei_shibou';
				if(param === 'q-5')	label = 'ota_chiryo_kyuen';
				if(param === 'q-7')	label = 'ota_option_kinkyu';
			}
			if(param === 'q-4') 	label = 'both_baisyo_sekinin';
			if(param === 'q-6') 	label = 'both_keikouhin';
			postUtagEvent(cat, UTAG_EVENT_JSON[1].ev_click, 'qa_'+ label, evVal);
		}
		else {
			switch (param) {
			case 'type':
				label = 'plan_'+this.m_Type.value;
				postUtagEvent(cat, UTAG_EVENT_JSON[1].ev_click, label, evVal); break;
			case 'yes':
				label = 'option';
				if (value === true)
					postUtagEvent(cat, UTAG_EVENT_JSON[1].ev_select, label, 'on');
				else
					postUtagEvent(cat, UTAG_EVENT_JSON[1].ev_select, label, 'off');						 
				break;
			}
		}
		// console.log('UtagEvent: '+cat);
	}

	/**
	 * 商品コード取得
	 */
	public get productCode(): string { 
		return this.m_ProductCode; 
	}
	// --------------------------------------------------------------------------
	
	// アクション  ---------------------------------------------------------------
	/**
	 * ヘルプ表示処理
	 */
	public onHelpShow(param: any): void {
		if (this.m_CollAndQuesMap.has(param)) {
			let ques = this.m_CollAndQuesMap.get(param);
			this.setViewMode('helpMode', ques);
		}
		else
			this.setViewMode('helpMode', param);
		this.setUtagEvent(param, null);
		this.refreshModel();
	}

	/**
	 * ヘルプ閉じる処理
	 */
	public onClose(param: any): void {
		this.setViewMode('helpMode', '');
		this.refreshModel();
	}

	/**
	 * 画面遷移処理
	 */
	public onNext(): void {
		this.setSelectPlan();
		const req: ContractNoticeRequest = new ContractNoticeRequest();		
		// req.planCode = 'BU1';
		req.planCode = this.m_SelectPlanInfo.planCode;
		req.companyProductCode 	= this.productCode;
		req.agentCode 			= this.m_AgentCode;
		this.m_ContractNoticeService.searchContractNotice(this, req, (result) => {
			let NoticeSize: number 		= result.contractNoticeInfoList.length;
			this.m_ContractNoticeList 	= [];
			for (let i = 0; i < NoticeSize; i++)
				this.m_ContractNoticeList.push(result.contractNoticeInfoList[i]);
			this.setScopeModel('ContractNoticeInfo', this.m_ContractNoticeList);
			this.setListData('ContractNoticeInfo', this.m_ContractNoticeList);
			this.m_OthersInfo 			= new OthersInfo();
			this.m_OthersInfo.url		= result.importantCertificateUrl;
			// this.m_OthersInfo.agency 	= result.agentName;
			this.setScopeModel('OthersInfo', this.m_OthersInfo);
			this.pushPath('/step3_important');
		});
	}
	// --------------------------------------------------------------------------
	
	// privateメソッド -----------------------------------------------------------
	/**
	 * プラン情報設定処理
	 * @param idx 
	 * plan.totalPremium が stringとして入っているので（理由謎）、numberに変換
	 */
	private setPlan(idx: number): PlanInfo {
		const returnInfo: PlanInfo 	= new PlanInfo();
		let plan 					= this.m_PlanInfoList[idx];
		returnInfo.planCode 		= plan.planCode;
		returnInfo.totalPremium 	= Number(plan.totalPremium);
		// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 START
		// summaryの文字数が減ったため、改行の制御を廃止
		// returnInfo.summary 			= this.insertBr(idx, plan.summary);
		returnInfo.summary 			= plan.summary;
		// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 END
		returnInfo.planName 		= plan.planName;
		returnInfo.optionCode		= plan.optionCode;
		this.setJPUnit(idx);
		for(let key of this.m_CollKeyList) {
			for(let i=0; i<plan.collInfoList.length; i++) {
				let colKey = plan.collInfoList[i].collateralKey.indexOf(key);
				if (colKey >= 0) {
					if (key === 'AT30' || key === 'AT21') {
						returnInfo.value1 = plan.collInfoList[i].collateralAmount;
						this.setCollShortName(idx, 'label1', key);
						this.setCollAndQues(idx, key, 'q-1');
					}
					else if (key === 'AT31' || key === 'AT22') {
						returnInfo.value2 = plan.collInfoList[i].collateralAmount;
						this.setCollShortName(idx, 'label2', key);
						this.setCollAndQues(idx, key, 'q-2');
					}
					else if (key === 'AT32' || key === 'AT04') {
						returnInfo.value3 = plan.collInfoList[i].collateralAmount;
						this.setCollShortName(idx, 'label3', key);
						this.setCollAndQues(idx, key, 'q-3');
					}
					else if (key === 'AT33' || key === 'AT06') {
						returnInfo.value4 = plan.collInfoList[i].collateralAmount;
						this.setCollShortName(idx, 'label4', key);
						this.setCollAndQues(idx, key, 'q-4');
					}
					else if (key === 'AT34' || key === 'AT05') {
						returnInfo.value5 = plan.collInfoList[i].collateralAmount;
						this.setCollShortName(idx, 'label5', key);
						this.setCollAndQues(idx, key, 'q-5');
					}
					else if (key === 'AT35' || key === 'AT08') {
						returnInfo.value6 = plan.collInfoList[i].collateralAmount;
						this.setCollShortName(idx, 'label6', key);
						this.setCollAndQues(idx, key, 'q-6');
					}
					// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 START
					else if (key === 'ATXX') {
						returnInfo.value8 = plan.collInfoList[i].collateralAmount;
						this.setCollShortName(idx, 'label8', key);
						this.setCollAndQues(idx, key, 'q-8');
					}
					// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 END
				}
			}
		}
		return returnInfo;
	}


	/**
	 * 画面補償略称名設定処理
	 * （画面補償略称名：モーダルを表示する前の？の横のテキスト）
	 * @param label
	 * @param key 
	 */
	private setCollShortName(idx: number, label: string, key: string): void {
		if (idx === 0 ) {
			for (let collDispInfo of this.m_CollDispList) {
				if (collDispInfo.collateralKey === key) {
					this.m_CollateralShortNameInfo[label] = collDispInfo.collateralShortName;
				}
			}
		} 
	}

	/**
	 * 初期設定処理
	 */
	private setShowPlan(): void {
		// this.m_Type.value = 'standard';
		this.m_SelectPlanInfo 						= new SelectPlanInfo();
		this.m_SelectPlanInfo.planCode 				= null;
		// this.m_SelectPlanInfo.totalPremium 			= this.m_PlanInfo2.totalPremium * this.m_RiskFactorInfo.numberOfInsured;
		this.m_SelectPlanInfo.addExtraCoverageFlg 	= '0';
		this.setViewMode('totalPremium', 'first');
	}

	/**
	 * オプションモード・値設定処理
	 */
	private setOption(): void {
		this.setScopeModel('OptionInfo', this.m_OptionInfo);
		this.setScopeModel('OptionFlag', this.m_OptionFlg);
		if (this.m_OptionFlg) {
			this.m_OptionInfo.value7 = this.toJPUnit(this.m_OptionInfo.value7);
			this.setViewMode('optionView', 'option');
		}
		else
			this.setViewMode('optionView', '');
	}

	/**
	 * 告知事項画面から戻る際の選択プラン情報設定処理
	 */
	private setPrevPlan(): void {
		if (this.m_SelectPlanInfo.planCode === this.m_PlanInfo1.planCode || this.m_SelectPlanInfo.planCode === this.m_PlanInfo1.optionCode)
			this.m_Type.value = 'reasonable';
		else if(this.m_SelectPlanInfo.planCode === this.m_PlanInfo2.planCode || this.m_SelectPlanInfo.planCode === this.m_PlanInfo2.optionCode)
			this.m_Type.value = 'standard';
		else if(this.m_SelectPlanInfo.planCode === this.m_PlanInfo3.planCode || this.m_SelectPlanInfo.planCode === this.m_PlanInfo3.optionCode)
			this.m_Type.value = 'premium';
	}

	/**
	 * 告知事項画面から戻る際の選択プラン情報設定処理（オプション）
	 */
	private setPrevPlanOption(): void {
		if(this.m_OptionFlg)
			this.setViewMode('optionView', 'option');
		else
			this.setViewMode('optionView', '');
		if (this.m_SelectPlanInfo.planCode === this.m_PlanInfo1.optionCode
		 || this.m_SelectPlanInfo.planCode === this.m_PlanInfo2.optionCode
		 || this.m_SelectPlanInfo.planCode === this.m_PlanInfo3.optionCode){
			this.m_Yes.value = true;
			// window.setTimeout(this.checkOption.bind(this),10);
		}
	}

	/**
	 * オプションチェック処理
	 */
	private checkOption() : void {
		let element = <HTMLInputElement>document.getElementById('lb_yes');
		element.checked = true;
	}

	/**
	 * 選択プラン情報設定処理
	 */
	private setSelectPlan(): void {
		if (this.m_Type.value === 'reasonable')
			this.m_SelectPlanInfo.planCode = this.m_PlanInfo1.planCode;
		else if (this.m_Type.value === 'standard')
			this.m_SelectPlanInfo.planCode = this.m_PlanInfo2.planCode;
		else if (this.m_Type.value === 'premium')
			this.m_SelectPlanInfo.planCode = this.m_PlanInfo3.planCode;
		if (this.m_Yes.value === true) {
			this.m_SelectPlanInfo.addExtraCoverageFlg = '1';
			if (this.m_Type.value === 'reasonable')
				this.m_SelectPlanInfo.planCode = this.m_PlanInfo1.optionCode;
			else if (this.m_Type.value === 'standard')
				this.m_SelectPlanInfo.planCode = this.m_PlanInfo2.optionCode;
			else if (this.m_Type.value === 'premium')
				this.m_SelectPlanInfo.planCode = this.m_PlanInfo3.optionCode;
		}
		this.setScopeModel('SelectPlanInfo', this.m_SelectPlanInfo);
		this.selectAfUtagView();
	}

	/**
	 * Tealium Tag View 選択後処理
	 */
	private selectAfUtagView(): void {
		this.utagView.plancode 	= this.m_SelectPlanInfo.planCode;
		this.utagView.quote_amt = this.m_SelectPlanInfo.totalPremium;
		postUtagView(this.utagView, this.productCode);
	}

	/**
	 * 補償表示キーとクエスチョンキーの設定処理
	 */
	private setCollAndQues(idx: number, key: any, q: string): void {
		if(idx === 0) {
			if (this.m_CollAndQuesMap.has(q) == false)
				this.m_CollAndQuesMap.set(q, key);
		}
	}
	/**
	 * 数値 -> 日本円単位設定処理
	 */
	private setJPUnit(idx: number): void {
		let collSize = this.m_PlanInfoList[idx].collInfoList.length;
		for (let j=0; j<collSize; j++) {
			let cInfo = this.m_PlanInfoList[idx].collInfoList[j];
			// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 START
			// if (cInfo.collateralAmount.includes('-') !== true) {
			if (cInfo.collateralAmount.includes('-') !== true && cInfo.collateralAmount.includes('無制限') !== true) {
			// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 END
				cInfo.collateralAmount = this.toJPUnit(cInfo.collateralAmount);
			}
		}
	}

	/**
	 * brタグ挿入処理
	 */
	private insertBr(idx: number, planSum: string): string {
		const br = '<br className=\'c-md-br\'/>';
		let st: string = null;
		let en: string = null;
		if (idx === 0) {
			st = planSum.slice(0,7);
			en = planSum.slice(7);
		}
		else if (idx === 1) {
			st = planSum.slice(0,7);
			en = planSum.slice(7);
		}
		else {
			st = planSum.slice(0,8);
			en = planSum.slice(8);
		}
		return st+br+en;
	}
	// --------------------------------------------------------------------------
}
